import { withInstall } from '@element-plus/utils'

import Transfer from './src/transfer.vue'

export const ElTransfer = withInstall(Transfer)
export default ElTransfer

export * from './src/transfer'
